export default __webpack_public_path__ + "img/PiHdoNbr.e91aaa00.svg";